import { VideoStory } from "../../types/VideoReduxState";

import { COJP_SITE } from "../../constants/Sites";

const SITE_CONFIG_MAP = {
    [COJP_SITE]: {
        defaultAdCode: "japan/general",
        brand: "cojp",
        parselySite: "bloomberg.co.jp",
    },
    default: {
        defaultAdCode: "business/general",
        brand: "bbiz",
        parselySite: "bloomberg.com",
    },
};
const DEFAULT_OPTIONS = {
    pageType: "content",
    template: "multimedia-video-html",
    transporter: "false",
    refresh: "false",
    autoplay: true,
};

const VIDEO_LANDING_PAGE_OPTIONS = {
    pageType: "sectionfront",
    contentType: "sectionfront-videov3",
    previousAction: "video-landing-page",
};

interface Options {
    site?: string;
    previousAction?: string;
    template?: string;
}

interface DefaultSiteConfigMap {
    defaultAdCode: string;
    brand: string;
    parselySite: string;
}
export default function generateVideoPageViewData(
    {
        adTargeting,
        publishedAt,
        id: storyId,
        topic,
        slug,
        video: { bmmrId } = {},
        isLandingPageVideo = false,
        site: videoSite,
        headline = {},
        attributor = "bn",
        type = "video",
        resourceType,
    }: Partial<VideoStory>,
    { site, previousAction, template }: Options = {}
) {
    const { defaultAdCode, brand, parselySite } =
        site && SITE_CONFIG_MAP[site]
            ? SITE_CONFIG_MAP[site]
            : (SITE_CONFIG_MAP.default as DefaultSiteConfigMap);
    const adcode = adTargeting?.adCode ?? defaultAdCode;
    const vertical = topic?.slug;
    const personalizationTrackingData =
        site === COJP_SITE
            ? {}
            : {
                  siteId: videoSite,
                  resourceId: bmmrId,
              };
    return {
        ...DEFAULT_OPTIONS,
        ...personalizationTrackingData,
        adcode,
        publishedAt,
        storyId,
        slug,
        vertical,
        attributor,
        contentType: `content-${type}`,
        headline: headline && headline.text,
        parselySite,
        brand,
        resourceType,
        ...(previousAction && { previousAction }),
        ...(isLandingPageVideo && VIDEO_LANDING_PAGE_OPTIONS),
        ...(template && { template }),
    };
}
